var map = {
	".": "oZzG",
	"./": "oZzG",
	"./01_get_Query_Invited_Users": "zsZ4",
	"./01_get_Query_Invited_Users.json": "zsZ4",
	"./02_get_Daily_Commission_Query": "Gwkw",
	"./02_get_Daily_Commission_Query.json": "Gwkw",
	"./03_get_Query_agent_user_nformation": "P9RC",
	"./03_get_Query_agent_user_nformation.json": "P9RC",
	"./04_get_Query_the_deposit_details": "7XUQ",
	"./04_get_Query_the_deposit_details.json": "7XUQ",
	"./05_get_Query_API_transaction_commission": "IoyB",
	"./05_get_Query_API_transaction_commission.json": "IoyB",
	"./06_get_Query_partner_information": "8au9",
	"./06_get_Query_partner_information.json": "8au9",
	"./07_get_referral_code_commission": "ZspE",
	"./07_get_referral_code_commission.json": "ZspE",
	"./08_get_Query_agent_superior_check": "YnmZ",
	"./08_get_Query_agent_superior_check.json": "YnmZ",
	"./index": "oZzG",
	"./index.js": "oZzG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "M3Xy";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/agent/api/agent ^.*$
// module id = M3Xy
// module chunks = 3